// extracted by mini-css-extract-plugin
export default {"cls1":"Rating-cls1__f27395475bd5bdc60813","cls2":"Rating-cls2___1358f89b614c9db2726 Rating-cls1__f27395475bd5bdc60813"};